import { all, takeLatest, call, put } from "redux-saga/effects";

import { authSuccess } from "./actions";
import { logoutSuccess } from "./actions";
import { alertRequest, alertSuccess } from "../alerts/actions";
import { clearInitialSettingsState } from "../initialSettings/actions";
import { changeApplicationLanguage } from "../language/actions";
import { clearChecklist } from "../checklist/actions";
import { clearEcommerceInfo } from "../ecommerce/actions";
import { clearProfileExhibitor } from "../profile/actions";
import { clearProfileServiceProvider } from "../profile/actions";
import { clearSystem } from "../system/actions";
import { clearEmployee } from "../employee/actions";
import { clearAllContractByEvent } from "../contract/actions";
import { clearAllEvent } from "../event/actions";
import api from "../../../service";

function* auth({ payload }) {
  const { email, password, keepSignedIn, callbackLoading } = payload;
  try {
    const authResponse = yield call(() =>
      api.post("auth/signin", { email, password })
    );
    yield put(clearInitialSettingsState());
    
    yield put(
      authSuccess({
        user: authResponse.data.user,
        token: authResponse.data.token,
        customerCenterToken: authResponse.data.customerCenterToken,
        accountCreated: authResponse.data.accountCreated,
        keepSignedIn,
      })
    );
    callbackLoading(false);
    yield put(
      changeApplicationLanguage({
        code: authResponse.data.user.language,
      })
    );
    yield put(clearInitialSettingsState());
    yield put(clearChecklist());
    yield put(clearEmployee());
    yield put(clearProfileExhibitor());
    yield put(clearProfileServiceProvider());
    yield put(clearEcommerceInfo());
    yield put(clearAllContractByEvent());
    yield put(clearAllEvent());
    yield put(clearSystem());
  } catch (error) {
    callbackLoading(false);
    yield put(
      alertRequest({
        title: "error",
        message: "api.error." + String(error.response.data.code),
        messageType: "error",
        isDialog: true,
      })
    );
  }
}

function* logout({ payload }) {
  const { token, callbackLoading, tokenExpired, user } = payload;
  try {
    yield call(() =>
      api.post("auth/logout", null, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      })
    );
    if (!tokenExpired) {
      yield put(
        alertSuccess({
          title: "success",
          message: "success.logged.out",
          messageType: "success",
          isDialog: true,
        })
      );
    } else {
      if (user?.role?.type === "ADMINISTRATOR") {
        window.location.href = process.env.REACT_APP_SERVER_URL + "saml/logout?local=true";
      }
    }
 
    yield put(logoutSuccess());
    yield put(clearInitialSettingsState());
    yield put(clearChecklist());
    yield put(clearEmployee());
    yield put(clearProfileExhibitor());
    yield put(clearProfileServiceProvider());
    yield put(clearEcommerceInfo());
    yield put(clearAllContractByEvent());
    yield put(clearAllEvent());
    yield put(clearSystem());
  } catch (error) {
    yield put(
      alertRequest({
        title: "error",
        message: "api.error." + String(error.response.data.code),
        messageType: "error",
        isDialog: true,
      })
    );
  } finally {
    callbackLoading(false);
  }
}

export default all([
  takeLatest("AUTH_REQUEST", auth),
  takeLatest("LOGOUT_REQUEST", logout),
]);
